/**
 * Keyboard utilities for handling cross-layout compatibility
 */

// Map of actions to their corresponding physical key codes
export const HOTKEYS = {
  RANDOMIZE: "KeyR", // Physical R key position on keyboard
  EASTER_EGG: "KeyG", // Physical G key position on keyboard
}

/**
 * Check if a keyboard event matches a specific physical key
 * This works across different keyboard layouts (QWERTY, AZERTY, QWERTZ, Dvorak, etc.)
 *
 * @param event The keyboard event
 * @param keyCode The physical key code to check against
 * @returns Whether the event matches the physical key
 */
export function matchesPhysicalKey(event: KeyboardEvent, keyCode: string): boolean {
  return event.code === keyCode
}

/**
 * Get a user-friendly display name for a physical key
 *
 * @param keyCode The physical key code
 * @returns A user-friendly display name
 */
export function getKeyDisplayName(keyCode: string): string {
  // Extract the letter part from KeyX format
  if (keyCode.startsWith("Key")) {
    return keyCode.slice(3)
  }
  return keyCode
}
